<template>
    <div id="new-waba-channel-form" style="margin-top: 100px">
        <a-form>
            <div class="form-wrapper">
                <div class="input-wrapper">
                    <label>{{ $t("whatsappChannel.channelName") }}</label>
                    <a-input
                        :placeholder="$t('whatsappChannel.channelName')"
                        v-model="clone.name"
                        v-validate="'required'"
                        name="channelName"
                    />
                </div>

                <div class="input-wrapper">
                    <label>{{ $t("whatsapp_business_api.phoneNumberE164") }}</label>
                    <a-input
                        :placeholder="$t('whatsapp_business_api.phoneNumberE164Place')"
                        v-model="clone.payload.phoneNumber"
                        v-validate="'required'"
                        name="phoneNumber"
                    />
                </div>
                <div class="input-wrapper">
                    <div class="mt-1 mb-1">
                        <a-switch :checked="!!clone.forward.stroy" @click="toggleChatbot" />
                        <span>👉 {{ $t("whatsappChannel.forwardToChatbot") }}</span>
                    </div>
                    <div class="mt-1 mb-1">
                        <a-switch v-model="clone.enabled" />
                        <span>{{
                            clone.enabled ? $t("whatsapp.channelSwitchOnEmoji") : $t("whatsapp.channelSwitchOffEmoji")
                        }}</span>
                    </div>
                    <label>{{ $t("whatsappChannel.forwardingChatbotOrLiveAgent") }}</label>
                    <a-select
                        v-model="clone.forward.stroy"
                        @change="handleStoryChange"
                        :defaultValue="null"
                        :notFoundContent="$t('whatsapp.notFoundContentForwardLiveAgents')"
                        :disabled="!showStories"
                    >
                        <a-select-option
                            v-if="!checkHaveChatbotStroy(clone.forward.stroy)"
                            :selected="true"
                            :value="null"
                        >
                            👉 {{ $t("whatsapp.forwardLiveAgents") }}
                        </a-select-option>
                        <a-select-option :key="story._id" v-for="story in stories" :value="story._id">
                            {{ story.title }}
                        </a-select-option>
                    </a-select>
                    <br />
                    <label>{{ $t("whatsapp.departmentForwarding") }}</label>
                    <a-select v-model="clone.forward.department" @change="getSubjectTitle" :defaultValue="null">
                        <a-select-option :selected="true" :value="null">👉{{ $t("whatsapp.selectedDepartment") }}</a-select-option>
                        <a-select-option :key="department._id" v-for="department of subjects" :value="department._id">
                            {{ getSubjectTitle(department) }}
                        </a-select-option>
                    </a-select>
                </div>
                <VisibilityChanger v-model="clone.visibility" />
            </div>
        </a-form>

        <div class="form-footer">
            <div class="actions">
                <button class="pr-confirm-btn save-btn" @click="updateChannelData" type="primary" :disabled="loading">
                    {{ $t("billing.save") }}
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import { sendSocketMessage } from "../../../utils/socketStream";
import VisibilityChanger from "./VisibilityChanger.vue";
import _ from "lodash";

export default {
    name: "SettingsMultiWhatsapp",
    components: { VisibilityChanger },
    props: {
        channel: {
            type: Object,
            default: {},
        },
    },
    data() {
        return {
            showStories: false,
            loading: false,
            clone: this.$_.cloneDeep(this.channel),
        };
    },
    computed: {
        ...mapState({
            stories: (state) => state.CB.stories,
            siteId: (state) => _.get(state.site.site, "_id"),
            subjects: (state) => _.get(state.subject.subjects, "data", []) || [],
        }),
    },
    methods: {
        ...mapActions({
            updateChannel: "channel/updateChannel",
        }),
        toggleChatbot() {
            if (this.showStories) {
                this.clone.forward.stroy = null;
            } else {
                if (this.stories[0]) {
                    this.clone.forward.stroy = this.stories[0]._id;
                }
            }
            this.showStories = !this.showStories;
        },
        handleStoryChange() {},
        checkHaveChatbotStroy(id) {
            return this.stories.find((story) => story._id === id);
        },
        updateChannelData() {
            const isValid = true;
            if (isValid) {
                this.loading = true;
                this.updateChannel(this.clone)
                    .then(() => {
                        this.$message.success("Channel updated successfully");
                        sendSocketMessage("user wp-channel-updated", {
                            siteId: this.siteId,
                        });
                        this.$emit("ok", this.clone);
                    })
                    .catch((err) => {
                        this.$message.error("Failed to update channel");
                    })
                    .finally(() => {
                        this.loading = false;
                    });
            }
        },
        getSubjectTitle(department) {
            const validLangs = Object.keys(department.languageContent);
            const targetLang = validLangs.includes(this.$i18n.locale) ? this.$i18n.locale : validLangs[0];
            const key = `languageContent.${targetLang}.name`;
            return _.get(department, key);
        },
    },
    mounted() {},
    beforeDestroy() {},
};
</script>

<style lang="scss" scoped>
#new-waba-channel-form {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background-color: #fff;
    border-radius: 8px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    padding: 20px;
    display: flex;
    flex-direction: column;
    width: 400px;
    max-width: 90%;
    z-index: 999;

    .form-wrapper {
        display: flex;
        flex-direction: column;
        gap: 20px;
        padding: 20px;

        .input-wrapper {
            display: flex;
            flex-direction: column;
            gap: 10px;
        }

        label {
            font-weight: bold;
            font-size: 14px;
            color: #333;
        }

        .a-input {
            padding: 10px;
            border: 1px solid #ccc;
            border-radius: 5px;
            font-size: 14px;
        }

        .a-select {
            width: 100%;
        }

        .a-switch {
            display: flex;
            align-items: center;
            gap: 10px;
            font-size: 14px;
        }
    }

    .form-footer {
        display: flex;
        justify-content: flex-end;
        align-items: center;
        padding-top: 20px;
        border-top: 1px solid #e1e1e1;
        margin-top: 30px;

        .actions {
            display: flex;
            align-items: center;
            gap: 10px;

            .cancel-btn {
                color: #666;
                font-size: 14px;
                cursor: pointer;
                transition: color 0.3s;

                &:hover {
                    color: #333;
                }
            }

            .pr-confirm-btn {
                background-color: #007bff;
                color: #fff;
                border: none;
                border-radius: 5px;
                padding: 10px 20px;
                font-size: 14px;
                cursor: pointer;
                transition: background-color 0.3s;

                &:disabled {
                    background-color: #ccc;
                    cursor: not-allowed;
                }

                &:hover:enabled {
                    background-color: #0056b3;
                }
            }
        }
    }
}

.save-btn {
    background-color: green;
    color: white;
    border: none;
    padding: 10px 20px;
    border-radius: 5px;
    cursor: pointer;
}

.save-btn:hover {
    background-color: #0056b3;
}
</style>

<style lang="scss">
.new-waba {
    .custom-modal-body {
        padding: 0 !important;
    }
}
</style>
